"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _tab = require("./tab");

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PdpTabs = function (_React$PureComponent) {
  _inherits(PdpTabs, _React$PureComponent);

  function PdpTabs(props) {
    _classCallCheck(this, PdpTabs);

    return _possibleConstructorReturn(this, (PdpTabs.__proto__ || Object.getPrototypeOf(PdpTabs)).call(this, props));
  }

  _createClass(PdpTabs, [{
    key: "render",
    value: function render() {
      var tabOrMobileBP = this.props.isTabOrMobileBP || '';

      return _react2.default.createElement(
        "div",
        { className: "nav-menu font-black left-0 right-0 " + tabOrMobileBP + " print-hide" },
        _react2.default.createElement(
          "div",
          { className: "margin-auto border-vertical-super-black-1" },
          _react2.default.createElement(
            "div",
            { className: "container padding-all-0" },
            _react2.default.createElement(
              "ul",
              { className: "nav nav-justified nav-custom", "data-testid": "nav-pills", role: "tablist" },
              this.returnTabs()
            )
          )
        ),
        _react2.default.createElement("div", { className: "padding-horizontal-20" })
      );
    }
  }, {
    key: "returnTabs",
    value: function returnTabs() {
      var _props = this.props,
          fundTypeCode = _props.fundTypeCode,
          tabProps = _props.tabProps,
          listOfAllTabs = _props.listOfAllTabs,
          updateTabState = _props.updateTabState;

      var commonTabProps = {
        clickHandler: updateTabState,
        fundTypeCode: fundTypeCode
      };

      if ((0, _ramda.isNil)(listOfAllTabs) || (0, _ramda.isEmpty)(listOfAllTabs) || (0, _ramda.isNil)(tabProps)) {
        return null;
      } else {
        {
          return mapIndexed(function (tabName, i) {
            if (tabProps[tabName].shouldRender) {
              return _react2.default.createElement(_tab2.default, _extends({ key: i }, commonTabProps, tabProps[tabName]));
            }
          }, listOfAllTabs);
        }
      }
    }
  }]);

  return PdpTabs;
}(_react2.default.PureComponent);

exports.default = PdpTabs;